import { IconList } from "@/components/IconList";
import { Link } from "@/components/Link";
import { Typography } from "@/components/Typography";
import { Icons } from "@/types/icons";
import { checkValidURL } from "@/utils/formHelper";
import type { BusinessContactInfoProps } from "../types";

export const BusinessContactInfo = ({ data, translations }: BusinessContactInfoProps) => {
  const { contactName, contactPhone, contactEmail, contactWebsite } = data;

  return (
    <div className="u-card">
      <IconList
        iconItem
        items={{
          icon: Icons.building,
          title: translations?.preview_contact_information,
        }}
        tag="h6"
        semibold
      />

      {contactName && (
        <>
          <Typography
            Tag="p"
            size="xs"
            classname="u-spacing-0 u-grey"
          >
            {translations?.preview_name}
          </Typography>
          <Typography
            Tag="p"
            size="xs"
          >
            {contactName}
          </Typography>
        </>
      )}

      {contactPhone && (
        <>
          <Typography
            Tag="p"
            size="xs"
            classname="u-spacing-0 u-grey"
          >
            {translations?.preview_phone}
          </Typography>
          <Typography
            Tag="p"
            size="xs"
          >
            <Link
              externalLink
              className="business-link"
              href={`tel:${contactPhone}`}
              prefetch={false}
            >
              {contactPhone}
            </Link>
          </Typography>
        </>
      )}

      {contactEmail && (
        <>
          <Typography
            Tag="p"
            size="xs"
            classname="u-spacing-0 u-grey"
          >
            {translations?.preview_email}
          </Typography>
          <Typography
            Tag="p"
            size="xs"
          >
            <Link
              externalLink
              className="business-link"
              href={`mailto:${contactEmail}`}
              prefetch={false}
            >
              {contactEmail}
            </Link>
          </Typography>
        </>
      )}

      {contactWebsite && (
        <>
          <Typography
            Tag="p"
            size="xs"
            classname="u-spacing-0 u-grey"
          >
            {translations?.preview_website}
          </Typography>
          <Typography
            Tag="p"
            classname="u-spacing-0"
            size="xs"
          >
            <Link
              externalLink
              className="business-link"
              href={checkValidURL(contactWebsite) || ""}
              prefetch={false}
            >
              {contactWebsite}
            </Link>
          </Typography>
        </>
      )}
    </div>
  );
};
